export default "__VITE_ASSET__DsX0zQoI__"